import { LAB_ONBOARDING_STEPS, type LabOnboardingStep } from './limsCommon';

export const LAB_ONBOARDING_ROUTES: Record<LabOnboardingStep, string> = {
  'lab-profile': '/onboarding/lab-profile',
  methods: '/onboarding/lab-methods',
  team: '/onboarding/lab-team',
  'first-client': '/onboarding/lab-first-client',
  finish: '/onboarding/lab-first-client',
};

export function nextIncompleteLabOnboardingHref(labOnboarding?: {
  completedSteps?: string[];
  currentStep?: string;
} | null): string {
  const completed = new Set<string>(labOnboarding?.completedSteps || []);
  for (const step of LAB_ONBOARDING_STEPS) {
    if (step === 'finish') continue;
    if (!completed.has(step)) {
      return LAB_ONBOARDING_ROUTES[step];
    }
  }
  const current = String(labOnboarding?.currentStep || '').trim() as LabOnboardingStep;
  if (current && LAB_ONBOARDING_ROUTES[current]) {
    return LAB_ONBOARDING_ROUTES[current];
  }
  return '/onboarding/lab-profile';
}

export function labOnboardingProgress(labOnboarding?: { completedSteps?: string[] } | null): {
  completed: number;
  total: number;
} {
  const completed = (labOnboarding?.completedSteps || []).filter((s) =>
    (LAB_ONBOARDING_STEPS as readonly string[]).includes(s)
  ).length;
  const total = LAB_ONBOARDING_STEPS.filter((s) => s !== 'finish').length;
  return { completed, total };
}
